import { connect } from 'react-redux';
import OrganisationSelector from './OrganisationSelector';

const mapStateToProps = ({ currentOrganisation, organisations }) => ({
  organisations,
  currentOrganisation,
});

const mapDispatchToProps = () => ({});

const OrganisationSelectorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganisationSelector);

export default OrganisationSelectorContainer;



// WEBPACK FOOTER //
// ./src/components/OrganisationSelector/OrganisationSelectorContainer.js